import {IMerchant} from '../interfaces/payment/IMerchant';
import {IAnalyticsData} from '../components/KKMControlContainer/KKMControl/type/IAnalyticsData';

export const calculateMerchantsAnalytics = (merchants: IMerchant[]): IAnalyticsData => {
    let totalMerchants = 0;
    let totalKKMs = 0;
    let totalPaymentDue = 0;

    merchants.forEach(merchant => {
        totalMerchants += 1;

        if (merchant.kkm_list && Array.isArray(merchant.kkm_list)) {
            totalKKMs += merchant.kkm_list.length;

            merchant.kkm_list.forEach(kkm => {
                const hasActiveDisconnect = Array.isArray(kkm.service_disconnect) && kkm.service_disconnect.some(d => !d.turn_on_date);

                if (hasActiveDisconnect || !kkm.create_payment_info || kkm.create_payment_info.balance_control_disabled) {
                    return;
                }

                const nextMonthPrice = kkm.create_payment_info.upcoming_payment_amount || kkm.create_payment_info.payment_amount_by_rent || 0;
                if (nextMonthPrice <= 0) {
                    return;
                }

                const leftover = Math.max(0, kkm.balance_value);
                totalPaymentDue += Math.max(0, nextMonthPrice - leftover);
            });
        }
    });

    return {
        totalMerchants,
        totalKKMs,
        totalPaymentDue,
    };
};
